import * as theme from "../theme";

import styled from "styled-components";

const HiddenInput = ({ isShow }) => {
  return (
    <InfoTextContainer className={"hidden-input-container"} isShow={isShow}>
      <div className={"d-none"}>
        <input id="leadid_token" name="universal_leadid" type="hidden"></input>
        <div id={"tcpa"}>
          <input id="leadid_tcpa_disclosure" type="hidden"></input>
          <label htmlFor="leadid_tcpa_disclosure">
            <p>By Clicking on the above Next button and sharing your contact information, you expressly consent to receive transactional and marketing calls, texts, and emails from Peklava LLC d/b/a Ratezip and/or up to five (5) of RateZip's <a href="https://www.ratezip.com/network-members/" target="_blank" rel="noreferrer">participating lenders</a> using a manual or automated system and/or prerecorded messages, even if you are on a State or Federal Do-Not-Call List. Your consent is not required for doing business with Peklava LLC d/b/a Ratezip, and you can revoke consent at any time. Message frequency varies and message and data rates may apply. To speak with someone at Peklava LLC d/b/a Ratezip, please call 203-594-1328. For SMS message campaigns: Text STOP to (866)362-7999 to stop and HELP for help. Msg & data or carrier rates may apply.</p>
          </label>
          <p>
            You confirm you have received and reviewed the <a href="https://www.ratezip.com/licenses-and-disclosures/" target="_blank" rel="noreferrer">Mortgage Broker Disclosures</a> for your state. <a href="https://www.nmlsconsumeraccess.org/TuringTestPage.aspx?ReturnUrl=/EntityDetails.aspx/COMPANY/1592292" target="_blank" rel="noreferrer">Peklava LLC, DBA RateZip NMLS ID 1592292</a>. By clicking "Next" you hereby consent, acknowledge, and agree to the <a href="https://www.ratezip.com/privacy-and-security/" target="_blank" rel="noreferrer">privacy policy</a> and agree to receive notices and other communications electronically.
          </p>
        </div>
      </div>
    </InfoTextContainer>
  );
};

const InfoTextContainer = styled.div`
  transform: translateY(10px);
  display: ${(p) => !p.isShow && "none"} !important;
  width: 1255px;

  @media (max-width: ${theme.tablet}) {
    width: calc(100% - 40px);
  }

  @media (max-width: ${theme.mobile}) {
    width: 330px;
  }

  #tcpa {
    display: "none" !important;
    width: 100%;

    /* Apply styles to all p elements inside #tcpa */
    p {
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: #666666;

      > a {
        color: ${theme.primary_light};
        text-decoration: none;
      }
    }

    @media (max-width: ${theme.mobile}) {
      margin: 1rem 0 5rem 0;
      p {
        color: #666666;
        font-size: 15px;
        line-height: 16px;
      }
    }
  }
`;

export default HiddenInput;
